import Vue from 'vue';

import DatePicker from './DatePicker';
import Multiselect from './Multiselect';
import Avatar from './Avatar';
import ConfirmModal from './Modal/ConfirmModal';
import Modal from './Modal/Modal';
import Toast from './Toast/Toast';
import PositionFilter from './PositionFilter';
import Toggle from './Toggle';

Vue.component('DatePicker', DatePicker);
Vue.component('Avatar', Avatar);
Vue.component('Multiselect', Multiselect);
Vue.component('Modal', Modal);
Vue.component('PositionFilter', PositionFilter);
Vue.component('Toggle', Toggle);

Vue.prototype.$toast = Toast;
Vue.prototype.$confirm = ConfirmModal;
